<!--海森介绍-->
<template>
  <div>
    <div class="header">
      <div class="header-center">
      <div class="header-logo">
        <img class="header-logo-img" src="static/header/headerImg.png"
             @click="toPage('home','')">
      </div>
      <div class="header-menu" @mouseover="shrinkMenuPanelShow(0)"
           @mouseleave="shrinkMenuPanelHide">
        <div class="header-menu-item"
             v-bind:class="{ 'header-menu-item-selected': headerMenuCurrentKey=='home' }"
             @click="toPage('home','')">首页
          <div class="header-menu-item-footer"
               v-bind:class="{ 'header-menu-item-footer-selected': headerMenuCurrentKey=='home' }"></div>
        </div>
        <div class="header-menu-item"
             v-bind:class="{ 'header-menu-item-selected': headerMenuCurrentKey=='about'}"
             @click="toPage('about','')" @mouseover="shrinkMenuPanelShow(1)"
             @mouseleave="shrinkMenuPanelHide">关于
          <div class="header-menu-item-footer"
               v-bind:class="{ 'header-menu-item-footer-selected': headerMenuCurrentKey=='about' }"></div>
        </div>
        <div class="header-menu-item"
             v-bind:class="{ 'header-menu-item-selected': headerMenuCurrentKey=='service'}"
             @click="toPage('service','')" @mouseover="shrinkMenuPanelShow(2)"
             @mouseleave="shrinkMenuPanelHide">服务
          <div class="header-menu-item-footer"
               v-bind:class="{ 'header-menu-item-footer-selected': headerMenuCurrentKey=='service' }"></div>
        </div>
        <div class="header-menu-item"
             v-bind:class="{ 'header-menu-item-selected': headerMenuCurrentKey=='solution'}"
             @click="toPage('solution','')"
             @mouseover="shrinkMenuPanelShow(3)"
             @mouseleave="shrinkMenuPanelHide">解决方案
          <div class="header-menu-item-footer-jjfa"
               v-bind:class="{ 'header-menu-item-footer-jjfa-selected': headerMenuCurrentKey=='solution' }">
          </div>
        </div>
        <div class="header-menu-item"
             v-bind:class="{ 'header-menu-item-selected': headerMenuCurrentKey=='contact'}"
             @click="toPage('contact','')" @mouseover="shrinkMenuPanelShow(4)"
             @mouseleave="shrinkMenuPanelHide">联系
          <div class="header-menu-item-footer"
               v-bind:class="{ 'header-menu-item-footer-selected': headerMenuCurrentKey=='contact' }"></div>
        </div>
      </div>
      </div>
    </div>
    <!--伸缩菜单-->
    <div id="shrink-menu-panel" class="shrink-menu-panel" @mouseover="shrinkMenuPanelShow"
         @mouseleave="shrinkMenuPanelHide">
      <div class="shrink-menu-blank"/>
      <div class="shrink-menu-area">
        <div class="shrink-menu"></div>
        <!--          服务-->
<!--        <div class="shrink-menu-gyhs" v-show="gyhsShow" @mouseover="shrinkMenuPanelShow(1)"-->
<!--             @mouseleave="shrinkMenuPanelHide">-->
<!--          <div class="shrink-menu-item"-->
<!--               @click="toPage('about','hastenIntroduce')"-->
<!--               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='hastenIntroduce' }">海森介绍-->
<!--          </div>-->
        <div class="shrink-menu-fw" v-show="hscpShow" @mouseover="shrinkMenuPanelShow(2)"
             @mouseleave="shrinkMenuPanelHide">
          <div class="shrink-menu-item"
               @click="toPage('service','marketingManagement')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='marketingManagement' }">市场营销
          </div>
          <div class="shrink-menu-item"
               @click="toPage('service','medicalAffairs')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='medicalAffairs' }">医学事务
          </div>
          <div class="shrink-menu-item"
               @click="toPage('service','development')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='development' }">研发事务
          </div>
          <div class="shrink-menu-item"
               @click="toPage('service','salesTransactions')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='salesTransactions' }">销售事务
          </div>
          <div class="shrink-menu-item"
               @click="toPage('service','supplyChainTransactions')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='supplyChainTransactions' }">供应链事务
          </div>
        </div>
        <!--        解决方案-->
        <div class="shrink-menu-jjfa" v-show="hsywShow" @mouseover="shrinkMenuPanelShow(3)"
             @mouseleave="shrinkMenuPanelHide">
          <div class="shrink-menu-item"
               @click="toPage('solution','brandDesign')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='brandDesign' }">品牌设计
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','medicalDigitalization')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='medicalDigitalization' }">医疗数字化
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','platformVisual')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='platformVisual' }">平台视觉包装
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','officialAccount')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='officialAccount' }">公众号运营
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','hotPosters')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='hotPosters' }">热点海报
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','videoCreativity')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='videoCreativity' }">视频创意
          </div>
          <div class="shrink-menu-item"
               @click="toPage('solution','demoDesign')"
               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='demoDesign' }">演示设计
          </div>
<!--          <div class="shrink-menu-item"-->
<!--               @click="toPage('solution','brandDesign')"-->
<!--               v-bind:class="{ 'shrink-menu-item-selected': shrinkMenuCurrentKey=='nowHas' }">数字平台搭建-->
<!--          </div>-->
        </div>
        <!--          -->
        <div class="shrink-menu-jrhs" v-show="jrhsShow" @mouseover="shrinkMenuPanelShow(4)"
             @mouseleave="shrinkMenuPanelHide">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['headerMenuSelectedKey', 'shrinkMenuSelectedKey'],
  data() {
    return {
      headerMenuCurrentKey: this.headerMenuSelectedKey,
      shrinkMenuCurrentKey: this.shrinkMenuSelectedKey,
      gyhsShow: false,
      hscpShow: false,
      hsywShow: false,
      jrhsShow: false,
      wxShow: false
      // showCancel: false
    };
  },
  watch: {
    shrinkMenuSelectedKey(val) {
      this.shrinkMenuCurrentKey = val
    }

  },
  methods: {
    productNowHasHide() {
      let menu = document.getElementById("nowHasLi");
      menu.style.display = 'none';
      this.showCancel = false;
    },
    //展开伸缩菜单面板
    shrinkMenuPanelShow(type) {
      if (type !== 0) {
        let menu = document.getElementById("shrink-menu-panel");
        menu.style.display = 'inherit';
        if (type === 1) {
          this.gyhsShow = true;
        } else if (type === 2) {
          this.hscpShow = true;
        } else if (type === 3) {
          this.hsywShow = true
        } else if (type === 4) {
          this.jrhsShow = true;
        }
      }
    },
    //隐藏伸缩菜单面板
    shrinkMenuPanelHide() {
      let menu = document.getElementById("shrink-menu-panel");
      // menu.style.zIndex = -999;
      menu.style.display = 'none';
      this.gyhsShow = false;
      this.hscpShow = false;
      this.hsywShow = false;
      this.jrhsShow = false;
    },
    toPage(path, location) {
      if (path == this.headerMenuCurrentKey) {
        //本页时，传递给父页面当前选定的值
        this.$emit('toLocation', location)
      } else {
        //跳转到其他页面时，先储存一个location值，供其他页面挂载时候用
        localStorage.setItem("location", location)
        //路由跳转
        this.$router.push('/' + path);
      }
    },
  },
}
</script>
<style scoped>
.header {
  z-index: 999;
  background: white;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.header-center {
  width: 1400px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-logo {
  float: left;
  text-align: center;
}

.header-logo-img {
  top: 14px;
  height: 32px;
  width: 92px;
  cursor: pointer
}

.header-menu {
  float: right;
  height: 60px;
  line-height: 60px;
  text-align: left;
  font-size: 22px;
  font-family: Source Han Sans CN;
  margin-left: 280px;
}

.header-menu-item {
  width: 120px;
  float: left;
  height: 60px;
  text-align: center;
  color: #000000;
  font-weight: bold;
}

.header-menu-item:hover {
  color: #D1121C;
  cursor: pointer;
}

.header-menu-item-footer {
  position: absolute;
  top: 45px;
  height: 3px;
  width: 50px;
  text-align: center;
}
.header-menu-item-footer-jjfa {
  position: absolute;
  top: 45px;
  height: 3px;
  width: 90px;
  text-align: center;
}

.header-menu-item:hover {
  color: #D1121C;
  cursor: pointer;
}

.shrink-menu-panel {
  width: 100%;
  height: 340px;
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 999;
  display: none;
}

.shrink-menu-blank {
  float: left;
  width: 1150px;
  height: 270px;
}

.shrink-menu-area {
  float: left;
  text-align: left;
  width: 700px;
  height: 270px;
  line-height: 270px;
}

.shrink-menu {
  width: 180px;
  font-size: 21px;
  float: left;
  font-family: Source Han Sans CN;
}

.shrink-menu-fw {
  width: 160px;
  font-size: 21px;
  float: left;
  margin-left: 130px;
  background: #FFFFFF;
  text-align: center;
  font-family: Source Han Sans CN;
}

.shrink-menu-jjfa {
  width: 160px;
  font-size: 21px;
  float: left;
  margin-left: 250px;
  background: #FFFFFF;
  text-align: center;
  font-family: Source Han Sans CN;
}

.shrink-menu-item {
  width: 160px;
  height: 40px;
  line-height:40px;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}

.shrink-menu-item:hover {
  color: #D1121C;
  cursor: pointer;
}

.shrink-menu-item-selected {
  color: #D1121C;
}

.header-menu-item-footer-selected {
  background-color: #D1121C;
}
.header-menu-item-footer-jjfa-selected {
  background-color: #D1121C;
}

.header-menu-item-selected {
  color: #D1121C;
  display: flex;
  align-content: center;
  justify-content: center;
}
.header-banner-box {
  width: 100%;
  height: 220px;
}
.header-banner{
  width:100%;
  height: 1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Header.vue